/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 11:39:50
 * @LastEditors: hongye
 * @LastEditTime: 2025-12-03 10:43:17
 * @Description: 国际化配置相关
 */

import { Locale } from 'ant-design-vue/lib/locale-provider'
// 语言类型
enum LangType {
  zh = 'CN',
  en = 'EN',
  ms = 'MY',
  vn = 'VN',
  id = 'ID',
  th = 'TH'
}

// 货币单位
enum LangCurrency {
  MY = 'RM',
  SG = 'S$',
  VN = 'VND',
  ID = 'IDR',
  TH = '฿'
}

const localeSuper = {
  [LangType.zh]: {
    type: LangType.zh,
    short: 'zh',
    name: '中文',
    dayjs: `dayjs/locale/zh-cn.js`,
    dayjsType: 'zh-cn'
  },
  [LangType.en]: {
    type: LangType.en,
    short: 'en',
    name: '英文',
    dayjs: `dayjs/locale/en.js`,
    dayjsType: 'en'
  },
  [LangType.ms]: {
    type: LangType.ms,
    short: 'ms',
    name: '马来语',
    dayjs: `dayjs/locale/ms-my.js`,
    dayjsType: 'ms-my'
  },
  [LangType.vn]: {
    type: LangType.vn,
    short: 'vn',
    name: '越南语',
    dayjs: `dayjs/locale/vi.js`,
    dayjsType: 'vi'
  },
  [LangType.id]: {
    type: LangType.id,
    short: 'id',
    name: '印尼语',
    dayjs: `dayjs/locale/id.js`,
    dayjsType: 'id'
  },
  [LangType.th]: {
    type: LangType.th,
    short: 'th',
    name: '泰语',
    dayjs: `dayjs/locale/th.js`,
    dayjsType: 'th'
  }
}
type LangJsonConfigType = {
  lang: LangType /** 语言类型 大写 */
  name: string /** 语言名称 */
  dayjs: string /** dayjs 语言包 */
  antd: Locale | undefined /** antd 语言包 */
  super: boolean /** 超级语言包 */
  superI18nPage: boolean /** 国际化页面枚举是否显示 */
}

export default LangType
export { LangType, LangJsonConfigType, LangCurrency, localeSuper }
